let homeHeader = {
  settings: {
    el: $('#home'),
    nav: $('nav')
  },
  init: function() {
    s = this.settings;
    $(window).scroll(function () {
      if ($(window).scrollTop() >= (s.el.offset().top - s.nav.height())) {
        s.nav.removeClass('hidden');
      } else {
        s.nav.addClass('hidden');
      }
    });
  }
}
let backToTop = {
  settings: {
    el: $('#back-to-top')
  },
  init: function() {
    se = this.settings;
    // Show only when scrolled
    $(window).scroll(function () {
      if ($(window).scrollTop() > 700) {
        se.el.removeClass('invisible');
      } else {
        se.el.addClass('invisible');
      }
    });
    // On click go back to top
    se.el.on('click', function(){
      offset = $('.filter').offset().top - $('nav.menu').height();
      $('html, body').animate({ scrollTop: offset }, 1000);
    });
  }
}

$(function(){
  // Sticky Nav only for Homepage, also BackToTop on Homepage
  if ($('html').hasClass('home')) { homeHeader.init(); backToTop.init(); }
  // Sticky Nav only on Posts pages
  if ($('html').hasClass('posts')) { backToTop.init(); }
  // InfiniteScroll Plugin
  $('.all-posts').infiniteScroll({
    path: '.pagination__next',
    append: 'article',
    history: false,
  });
});

$(window).load(function(){
  // Fully load on Homepage
  $('body').addClass('loaded');
});



// WEBPACK FOOTER //
// ./src/scripts/main.js